class VideoStorySection extends HTMLElement {
    constructor() {
        super();
        this.isMuted = true;
        this.isPaused = false;
        this.swiper = null;
        this.progressFrame = null;
        this.imageDuration = 5000;
        this.imageElapsed = 0;
        this.lastTimestamp = 0;
        this.hasSwiped = false;
        this.hasInteracted = false;
    }

    connectedCallback() {
        const desktopColumns = this.getAttribute('columns-desktop') || '4';
        const clickBehavior = this.getAttribute('click-behavior') || 'add_to_cart';

        this.mobileLayout = this.getAttribute('mobile-layout') || 'vertical';
        this.desktopLayout = this.getAttribute('desktop-layout') || 'horizontal';
        const slides = Array.from(this.querySelectorAll('story-slide')).map(el => ({
            type: el.getAttribute('type'),
            src: el.getAttribute('src'),
            thumb_src: el.getAttribute('thumb-video'),
            thumb: el.getAttribute('thumb'),
            pName: el.getAttribute('product-name'),
            pPrice: el.getAttribute('price'),
            pOldPrice: el.getAttribute('original-price'),
            pImg: el.getAttribute('product-img'),
            pDiscount: el.getAttribute('discount'),
            variantId: el.getAttribute('variant-id'),
            productUrl: el.getAttribute('product-url'),
            title: el.getAttribute('title'),
            ratio: el.getAttribute('ratio')
        }));

        this.innerHTML = `
        <div class="story-section">
            <div class="reel-grid-wrapper">

                <button class="grid-nav prev" aria-label="Scroll left">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                        <path d="M9 19L16 12L9 5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </button>

                <div class="reel-grid reel-grid-${desktopColumns}" style="--columns:${desktopColumns}">
                    ${slides.map((s, i) => `
                    <div class="thumb" onclick="this.closest('video-story-section').open(${i})">
                        <div class="thumb-media">
                        ${s.type === 'video' 
                            ? `
                                <div class="thumb-play-video-overlay center">
                                    <svg viewBox="0 0 20 20" width="20" height="20">
                                    <path fill-rule="evenodd" d="M15.375 8.485c1.167.674 1.167 2.358 0 3.031l-7.5 4.33c-1.167.674-2.625-.168-2.625-1.515v-8.66c0-1.348 1.458-2.19 2.625-1.516l7.5 4.33Zm-.75 1.732a.25.25 0 0 0 0-.433l-7.5-4.33a.25.25 0 0 0-.375.217v8.66a.25.25 0 0 0 .375.216l7.5-4.33Z"></path>
                                    </svg>
                                </div>
                                <video 
                                    class="thumb-video"
                                    data-src="${s.thumb_src}#t=0.1" 
                                    preload="none" 
                                    loop 
                                    muted 
                                    playsinline 
                                    poster="${s.thumb}">
                                </video>` 
                            : `
                            <div class="thumb-play-video-overlay center">
                                <svg viewBox="0 0 20 20" width="20" height="20">
                                <path fill-rule="evenodd" d="M15.375 8.485c1.167.674 1.167 2.358 0 3.031l-7.5 4.33c-1.167.674-2.625-.168-2.625-1.515v-8.66c0-1.348 1.458-2.19 2.625-1.516l7.5 4.33Zm-.75 1.732a.25.25 0 0 0 0-.433l-7.5-4.33a.25.25 0 0 0-.375.217v8.66a.25.25 0 0 0 .375.216l7.5-4.33Z"></path>
                                </svg>
                            </div>
                            <img src="${s.thumb}" loading="lazy">
                            `
                        }
                        </div>
                        <p class="thumb-title">${s.title}</p>
                    </div>
                    `).join('')}
                </div>

                <button class="grid-nav next" aria-label="Scroll right">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                    <path d="M9 19L16 12L9 5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </button>

            </div>
        </div>

        <div class="video-overlay">
            <div class="reel-swiper">
                <div class="swiper-wrapper">
                    ${slides.map(s => `
                    <div class="swiper-slide" data-type="${s.type}">
                        <div class="slide-inner">
                            <div class="progress-container"><div class="progress-bar"></div></div>
                            <div class="play-video-overlay">
                                <svg viewBox="0 0 20 20" width="20" height="20">
                                <path fill-rule="evenodd" d="M15.375 8.485c1.167.674 1.167 2.358 0 3.031l-7.5 4.33c-1.167.674-2.625-.168-2.625-1.515v-8.66c0-1.348 1.458-2.19 2.625-1.516l7.5 4.33Zm-.75 1.732a.25.25 0 0 0 0-.433l-7.5-4.33a.25.25 0 0 0-.375.217v8.66a.25.25 0 0 0 .375.216l7.5-4.33Z"></path>
                                </svg>
                            </div>
                            <button class="close-x" onclick="this.closest('video-story-section').close()">
                                <svg viewBox="0 0 20 20"><path d="M13.97 15.03a.75.75 0 1 0 1.06-1.06l-3.97-3.97 3.97-3.97a.75.75 0 0 0-1.06-1.06l-3.97 3.97-3.97-3.97a.75.75 0 0 0-1.06 1.06l3.97 3.97-3.97 3.97a.75.75 0 1 0 1.06 1.06l3.97-3.97 3.97 3.97Z"></path></svg>
                            </button>
                            <button class="mute-toggle mute is-muted">
                                <svg viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M8.866 4.324c.788-.788 2.134-.23 2.134.884v9.585c0 1.114-1.346 1.672-2.134.884l-2.603-2.603a.25.25 0 0 0-.177-.073h-1.336a1.75 1.75 0 0 1-1.75-1.75v-2.5c0-.967.784-1.75 1.75-1.75h1.336a.25.25 0 0 0 .177-.074l2.603-2.603Zm.634 1.487-2.177 2.177a1.75 1.75 0 0 1-1.237.512h-1.336a.25.25 0 0 0-.25.25v2.5c0 .139.112.25.25.25h1.336c.464 0 .909.185 1.237.513l2.177 2.177v-8.379Z"></path>
                                    <path class="sound-wave" style="--delay: 0s" d="M11.907 7.345a.75.75 0 0 1 1.047-.166 4.152 4.152 0 0 1 .496 6.294.75.75 0 0 1-1.061-1.06 2.65 2.65 0 0 0-.316-4.02.75.75 0 0 1-.166-1.048Z"></path>
                                    <path class="sound-wave" style="--delay: 0.15s" d="M14.62 4.886a.75.75 0 0 0-.881 1.214 5.486 5.486 0 0 1 .654 8.317.75.75 0 1 0 1.06 1.061 6.986 6.986 0 0 0-.833-10.592Z"></path>
                                </svg>
                            </button>
                            <div class="media-wrap media-ratio-${s.ratio}" style="height:100%" onclick="this.closest('video-story-section').togglePause()">
                                ${s.type === 'video' ? `<video data-src="${s.src}" poster="${s.thumb}" preload="none" playsinline muted></video>` : `<img data-src="${s.src}" loading="lazy">`}
                            </div>

                            ${s.pName ? `<div class="product-card" onclick="this.closest('video-story-section').handleProductClick(event, '${s.variantId}', '${s.productUrl}', this)">
                                <div class="mobile-scroll-indicator">
                                    <div class="mouse-scroll"></div>
                                    <span>Swipe Up</span>
                                </div>
                                ${s.pDiscount != "" ? `<span class="p-discount">${s.pDiscount} OFF</span>` : `` }                                    
                                <img src="${s.pImg}" class="p-img" loading="lazy">
                                <div class="p-details">
                                    <h4>${s.pName}</h4>
                                    <div class="p-price">${s.pPrice} <span class="p-old">${s.pOldPrice}</span></div>
                                    <div class="shop-now-row">
                                        <span>Shop Now</span> 
                                        <span>
                                            <svg class="shop-now-icon" data-name="Layer 1" viewBox="0 0 13.82 24.38"><path width="12" height="12" d="M11.32,28.72a1.64,1.64,0,0,0,2.3,0L24.18,18.15A1.6,1.6,0,0,0,24.66,17a1.63,1.63,0,0,0-.48-1.16L13.62,5.28a1.63,1.63,0,0,0-2.3,2.3L20.73,17l-9.41,9.41A1.63,1.63,0,0,0,11.32,28.72Z" transform="translate(-10.84 -4.82)"></path></svg>
                                        </span>
                                    </div>
                                </div>
                            </div>` : ''}
                        </div>
                    </div>`).join('')}
                </div>
                <div class="swiper-button-next">
                    <svg class="swiper-button-next-icon" data-name="Layer 1" viewBox="0 0 13.82 24.38"><path width="12" height="12" d="M11.32,28.72a1.64,1.64,0,0,0,2.3,0L24.18,18.15A1.6,1.6,0,0,0,24.66,17a1.63,1.63,0,0,0-.48-1.16L13.62,5.28a1.63,1.63,0,0,0-2.3,2.3L20.73,17l-9.41,9.41A1.63,1.63,0,0,0,11.32,28.72Z" transform="translate(-10.84 -4.82)"></path></svg>
                </div>
                <div class="swiper-button-prev">
                    <svg class="swiper-button-prev-icon" data-name="Layer 1" viewBox="0 0 13.82 24.38" width="12" height="12"><path d="M11.32,28.72a1.64,1.64,0,0,0,2.3,0L24.18,18.15A1.6,1.6,0,0,0,24.66,17a1.63,1.63,0,0,0-.48-1.16L13.62,5.28a1.63,1.63,0,0,0-2.3,2.3L20.73,17l-9.41,9.41A1.63,1.63,0,0,0,11.32,28.72Z" transform="translate(24.66 -4.82) scale(-1,1)"></path></svg>
                </div>
            </div>
        </div>`;

        this.initEvents();
        this.initGridNav();
        this.initGridObserver(); // Setup the observer for thumbnail videos
    }
    initGridNav() {
        const grid = this.querySelector('.reel-grid');
        const prev = this.querySelector('.grid-nav.prev');
        const next = this.querySelector('.grid-nav.next');

        if (!grid || !prev || !next) return;

        // --- Drag Variables ---
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false; 

        const getStep = () => {
            const item = grid.children[0];
            if (!item) return 300;
            const style = getComputedStyle(grid);
            const gap = parseInt(style.columnGap || style.gap) || 0;
            return item.offsetWidth + gap;
        };

        const updateButtons = () => {
            const maxScroll = grid.scrollWidth - grid.clientWidth;
            prev.classList.toggle('is-hidden', grid.scrollLeft <= 5);
            next.classList.toggle('is-hidden', grid.scrollLeft >= maxScroll - 5);
        };

        // Existing Button Logic
        prev.addEventListener('click', () => {
            grid.scrollBy({ left: -getStep(), behavior: 'smooth' });
        });

        next.addEventListener('click', () => {
            grid.scrollBy({ left: getStep(), behavior: 'smooth' });
        });

        // --- Mouse Drag Logic ---
        grid.addEventListener('mousedown', (e) => {
            isDown = true;
            isDragging = false;
            grid.classList.add('is-dragging'); // For CSS styling
            startX = e.pageX - grid.offsetLeft;
            scrollLeft = grid.scrollLeft;
            // Temporarily disable smooth snapping while dragging
            grid.style.scrollSnapType = 'none';
            grid.style.scrollBehavior = 'auto';
        });

        grid.addEventListener('mouseleave', () => {
            isDown = false;
            grid.classList.remove('is-dragging');
        });

        grid.addEventListener('mouseup', () => {
            isDown = false;
            grid.classList.remove('is-dragging');
            // Re-enable snapping and smooth behavior
            grid.style.scrollSnapType = 'x mandatory';
            grid.style.scrollBehavior = 'smooth';
        });

        grid.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            
            const x = e.pageX - grid.offsetLeft;
            const walk = (x - startX) * 2; // Scroll speed multiplier
            
            // If moved more than 5px, consider it a drag
            if (Math.abs(walk) > 5) {
                isDragging = true;
                grid.scrollLeft = scrollLeft - walk;
            }
        });

        // Prevent thumbnail click if we were just dragging
        grid.querySelectorAll('.thumb').forEach(thumb => {
            thumb.addEventListener('click', (e) => {
                if (isDragging) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            }, true);
        });

        grid.addEventListener('scroll', updateButtons);
        window.addEventListener('resize', updateButtons);
        updateButtons();
    }
    initEvents() {
        this.querySelectorAll('.mute-toggle').forEach(btn => {
            btn.onclick = (e) => {
                e.stopPropagation();
                this.isMuted = !this.isMuted;
                this.querySelectorAll('.media-wrap video').forEach(v => v.muted = this.isMuted);
                this.querySelectorAll('.mute-toggle').forEach(b => b.classList.toggle('is-muted', this.isMuted));
            };
        });
    }

    // NEW: Intersection observer to load/play grid videos ONLY when visible
    initGridObserver() {
        const options = {
            root: null,
            rootMargin: '100px', // Start loading slightly before it enters view
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const video = entry.target.querySelector('video');
                if (!video) return;

                if (entry.isIntersecting) {
                    // Swap data-src to src if it hasn't been done yet
                    if (video.dataset.src) {
                        video.src = video.dataset.src;
                        video.removeAttribute('data-src');
                        video.load();
                    }
                    video.play().catch(() => {}); // Catch autoplay restrictions
                } else {
                    // Pause video when out of view to save CPU/battery
                    if (!video.paused) {
                        video.pause();
                    }
                }
            });
        }, options);

        this.querySelectorAll('.thumb').forEach(thumb => {
            observer.observe(thumb);
        });
    }

    // NEW: Load media only for current and adjacent slides
    loadSlideMedia(index) {
        if (!this.swiper) return;
        
        // Target current, prev, and next slides for smooth transitions
        const slidesToLoad = [index - 1, index, index + 1];
        
        slidesToLoad.forEach(i => {
            const slide = this.swiper.slides[i];
            if (slide) {
                const mediaElements = slide.querySelectorAll('[data-src]');
                mediaElements.forEach(el => {
                    el.src = el.dataset.src;
                    el.removeAttribute('data-src');
                    if (el.tagName === 'VIDEO') {
                        el.load();
                    }
                });
            }
        });
    }

    togglePause() {
        this.isPaused = !this.isPaused;
        const active = this.swiper.slides[this.swiper.activeIndex];
        active.classList.toggle('is-paused', this.isPaused);
        const video = active.querySelector('video');
        
        if (video) {
            this.isPaused ? video.pause() : video.play();
        }

        if (!this.isPaused) {
            this.lastTimestamp = performance.now();
            this.runAnimation();
        }
    }

    open(idx) {
        this.querySelector('.video-overlay').classList.add('active');
        document.body.style.overflow = 'hidden';

        this.hasInteracted = false;
        const indicators = this.querySelectorAll('.mobile-scroll-indicator');
        indicators.forEach(el => el.classList.remove('is-hidden'));

        if (!this.swiper) {
            const isMobile = window.innerWidth < 768;
            this.swiper = new Swiper2(this.querySelector('.reel-swiper'), {
                direction: isMobile ? this.mobileLayout : this.desktopLayout,
                slidesPerView: isMobile ? 1 : 'auto',
                centeredSlides: true,
                spaceBetween: isMobile ? 0 : 20,
                allowTouchMove: isMobile,
                simulateTouch: isMobile,
                noSwiping: !isMobile,
                allowSlideNext: true,
                allowSlidePrev: true,
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
                on: { 
                    slideChange: () => this.syncPlayback(),
                    sliderMove: () => {
                        if (!this.hasInteracted) {
                            this.hasInteracted = true;
                            this.querySelectorAll('.mobile-scroll-indicator').forEach(el => {
                                el.classList.add('is-hidden');
                            });
                        }
                    }
                 }
            });
        }
        
        this.swiper.slideTo(idx, 0);
        this.syncPlayback();
    }

    close() {
        cancelAnimationFrame(this.progressFrame);
        this.querySelector('.video-overlay').classList.remove('active');
        document.body.style.overflow = '';
        this.querySelectorAll('video:not(.thumb-video)').forEach(v => { v.pause(); v.currentTime = 0; });
    }

    syncPlayback() {
        cancelAnimationFrame(this.progressFrame);
        this.isPaused = false;
        this.imageElapsed = 0;
        
        // Trigger lazy loading for the new active slide position
        this.loadSlideMedia(this.swiper.activeIndex);

        this.querySelectorAll('.swiper-slide').forEach(s => s.classList.remove('is-paused'));
        this.querySelectorAll('.media-wrap video').forEach(v => { v.pause(); v.currentTime = 0; });
        this.querySelectorAll('.progress-bar').forEach(b => b.style.width = '0%');

        const active = this.swiper.slides[this.swiper.activeIndex];
        const video = active.querySelector('video');
        if (video) {
            video.muted = this.isMuted;
            // Add a small delay to ensure the browser has parsed the new src from loadSlideMedia
            setTimeout(() => {
               video.play().catch(e => console.log('Autoplay prevented', e));
            }, 50);
        }
        this.lastTimestamp = performance.now();
        this.runAnimation();
    }

    runAnimation() {
        if (this.isPaused) return;
        const active = this.swiper.slides[this.swiper.activeIndex];
        const bar = active.querySelector('.progress-bar');
        const type = active.dataset.type;

        const frame = (timestamp) => {
            if (this.isPaused) return;

            if (type === 'video') {
                const video = active.querySelector('video');
                // Ensure video is valid and has duration before calculating
                if (video && !isNaN(video.duration) && video.duration > 0) {
                    const pc = (video.currentTime / video.duration) * 100;
                    bar.style.width = pc + '%';
                    if (video.ended) this.swiper.slideNext();
                    else this.progressFrame = requestAnimationFrame(frame);
                } else {
                     this.progressFrame = requestAnimationFrame(frame);
                }
            } else {
                const delta = timestamp - this.lastTimestamp;
                this.lastTimestamp = timestamp;
                this.imageElapsed += delta;
                const pc = Math.min((this.imageElapsed / this.imageDuration) * 100, 100);
                bar.style.width = pc + '%';
                if (pc >= 100) this.swiper.slideNext();
                else this.progressFrame = requestAnimationFrame(frame);
            }
        };
        this.progressFrame = requestAnimationFrame(frame);
    }

    handleProductClick(event, variantId, productUrl, el) {
        event.stopPropagation();
        const behavior = this.getAttribute('click-behavior') || 'add_to_cart';
        if (behavior === 'redirect') {
            window.location.href = productUrl;
        } else {
            this.addToCart(variantId, el);
        }
    }

    addToCart(variant_id, el){
        el.classList.add('is-loading');
        const data = {
            id: variant_id,
            quantity: 1
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(response => {
            if (response.status) {
                if (response.status == 422) {
                throw new Error('Not enough stock');
                }
                return;
            }

            var cart = new theme.CartDrawer;
            cart.init(); 
            cart.drawer.open();
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(() => {
            el.classList.remove('is-loading');
        });
    }
}

customElements.define('video-story-section', VideoStorySection);